<template>
  <Form :model="formData" :rules="formRules" :ref="`rulusForm${i}`" class="mr20 inline-b dynamic-form">
    <FormItem label="" >
      <Select v-model="formData.start" class="item-width" :disabled="true" size="small">
        <Option v-for="day in startList" :value="day.value" :key="day.value">{{day.text}}</Option>
      </Select>
    </FormItem>
    <div class="dash"><span></span></div>
    <FormItem label=""  prop="end">
      <Select v-model="formData.end" class="item-width" :disabled="disable" @on-change="changeEnd" size="small">
        <Option v-for="item in monthList" :value="item.value" :key="item.value">{{item.text}}</Option>
      </Select>
    </FormItem>

    <span class="pl16" v-if="basic">标准月租金 * </span>
    <FormItem label="" prop="waveValue"   class="w-80">
      <Input v-model="formData.waveValue" :disabled="disable" size="small">
        <span slot="append">%</span>
      </Input>
    </FormItem>
  </Form>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    basic:{
     type:Boolean,
     default:true
    },
    start:{
      type: Number,
      default:0
    },
    max:{
      type: Number,
      default:0
    },
    i:{
      type:Number,
      default:0
    },
    disable:{
      type: Boolean,
      default:false
    },
    waveData:{
      type:Object,
      default:null
    }
  },
  created(){
    let start = this.start
    let max = this.max
    this.startList = [{
        value: start ,
        text: start
      }]
      for(let i = start ; i<= max; i++){
        this.monthList.push({
          value:i,
          text:i
        })
      }
    for( let key in this.formData) {
      this.formData[key] = this.waveData[key]
    }
  },
  watch:{
    waveValue(){
      for( let key in this.formData) {
      this.formData[key] = this.waveData[key]
    }
    }
  },
  data () {
    const validateWaveNumber = (require,value,callback) => {
      let pattern = /^[1-9]\d*$/
      if(this.basic) {
        if(pattern.test(value) && +value >=100){
         callback()
        }else{
        callback(new Error(' '))
        }
      } else {
        if(pattern.test(value) && +value <= 100){
         callback()
        }else{
        callback(new Error(' '))
        }
      }
    }
    return {
      startList:[],
      monthList:[],
      formData:{
        start:0,
        end:11,
        waveValue:'',
      },
      formRules:{
        end:[{required: true, message:' ',type:'number',trigger:'change'}],
        waveValue:[{required: true,type:'number', validator:validateWaveNumber,trigger:'blur'}],
      }
    };
  },
  methods: {
    changeEnd(val) {

      //if(val<this.max) {
        let data = {
          i: this.i,
          preEnd: val
        }
        this.$emit('add-form',data)
      //}
    },
    formValidate() {
      let obj = {}
      this.$refs[`rulusForm${this.i}`].validate( bool => {
        if(bool){
            obj = this.formData
          // console.log('success')
        }else{
            obj = false
        }
      })
      return obj
    }
  }
}
</script>

<style lang="css" scoped>
.ivu-form-item {
  display: inline-block;
  width: 60px;
}
.dash {
  display: inline-block;
  padding-left: 4px;
  padding-right: 4px;
  line-height: 24px;
  text-align: center;
  }
  .dash span {
    display: inline-block;
    width: 8px;
    height: 2px;
    background: #dddee1;
    vertical-align: middle;
  }
  .w-80 {
    width: 80px;
  }
  .basic-rules .ivu-form-item-error-tip {
    top: 100%;
    left: 0;
  }

</style>
